import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../services/master/MasterService';

const MaksudKegiatan = ({id}) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [maksudKegiatan, setMaksudKegiatan] = useState('')

    useEffect(() => {
        const getmaksudKegiatan = async () => {
            const response = await masterService.getMaksudPengirimanById(id)
            setMaksudKegiatan(response.data.maksudPengiriman)
        }
        getmaksudKegiatan()
    }, [masterService, id])

    return (
        <>
            {maksudKegiatan}
        </>
    )
}

export default MaksudKegiatan